import { useEffect, useMemo, useState } from 'react';
import FilterService from '../Components/filters/FilterService';
import { resolveModuleListConfig } from '../Configurations/moduleListRegistry';

/**
 * Load list-page config: registry defaults + optional API module_config from metadata.
 *
 * @param {string} filterModule - system_modules.module_name
 * @param {string|null} variantKey - e.g. 'employee' | 'intern' for organization_project_tasks
 */
export function useModuleListConfig(filterModule, variantKey = null) {
  const [apiModuleConfig, setApiModuleConfig] = useState(null);
  const [loading, setLoading] = useState(Boolean(filterModule));

  useEffect(() => {
    if (!filterModule) {
      setLoading(false);
      return;
    }

    let cancelled = false;
    setLoading(true);

    FilterService.getFilterMetadata(filterModule)
      .then((res) => {
        if (cancelled) return;
        setApiModuleConfig(res.module_config || null);
      })
      .catch(() => {
        if (!cancelled) setApiModuleConfig(null);
      })
      .finally(() => {
        if (!cancelled) setLoading(false);
      });

    return () => {
      cancelled = true;
    };
  }, [filterModule]);

  const config = useMemo(
    () => resolveModuleListConfig(filterModule, variantKey, apiModuleConfig),
    [filterModule, variantKey, apiModuleConfig]
  );

  return { config, loading, apiModuleConfig };
}

export default useModuleListConfig;
